/**
 * @fileoverview Loading placeholder for KpiStrip.
 * @description Mirrors KpiStrip's 4-card grid (icon tile + label, value and sublabel lines) so
 * the page doesn't jump when the real KPIs arrive. Any page rendering KpiStrip behind a pending
 * query should render this in its place while that query is pending.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import Skeleton from '@/shared/components/atoms/Skeleton'

/**
 * @component
 */
function KpiStripSkeleton() {
  return (
    <section className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 lg:grid-cols-4">
      {[0, 1, 2, 3].map((index) => (
        <div
          key={index}
          className="flex items-center gap-3.5 rounded-xl border border-chip-border bg-white px-[18px] py-4"
        >
          <Skeleton width={46} height={46} variant="block" />
          <div className="flex flex-col gap-2">
            <Skeleton width={90} height={10} variant="block" />
            <Skeleton width={48} height={22} variant="block" />
            <Skeleton width={110} height={10} variant="block" />
          </div>
        </div>
      ))}
    </section>
  )
}

export default KpiStripSkeleton
